import { ContentPage } from "containers/ContentPage";
import { getSingle } from "shared/prismic";

export async function getStaticProps({ preview = null, previewData }) {
  const doc = await getSingle({ previewData, type: "about_us_overview" });
  return { props: { doc, preview } };
}

export default ContentPage;
